<template>
  <div class="overflow-auto fixed top-0 left-0 z-50 w-full" style="height: calc(100% - 50px);">
    <div ref="maskImg"
      @click="closeImgMask"
      class="fixed w-full h-full top-0 left-0 bg-lightText opacity-70 hidden z-60">
    </div>
    <div ref="openImgPanel"
      @click="closeImgMask"
      class="fixed top-0 left-0 hidden z-60 max-w-full max-h-full w-full h-full justify-center items-center">
      <img class="max-h-80% w-full h-full object-contain" :src="openImgs" alt="">
    </div>

    <div class="pt-3 absolute top-0 left-0 w-full text-center bg-white shadow-sm z-10">
      <div @click="closeMsg" class="absolute left-2.5 top-2.5">
        <svg t="1705290159922" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5020" width="28" height="28"><path d="M675.11798 267.269064L430.406848 511.992078l244.710142 244.723015a38.453744 38.453744 0 0 1-54.380252 54.383222l-271.900267-271.91116a38.455724 38.455724 0 0 1 0-54.382232l271.900267-271.91116a38.453744 38.453744 0 0 1 54.381242 54.375301z" fill="#000000" p-id="5021"></path></svg>
      </div>
      <div class="pb-3">Message</div>
    </div>
    <div ref="chatPanels" class="text-sm bg-white overflow-y-auto" style="height: calc(100% - 105px);margin-top: 48px;">
      <div class="px-3 pt-3 pb-14 ">
        <div v-show="manageAI" class="py-6 flex flex-col items-center">
          <img src="../../assets/gptIcon.png" class="w-16" alt="">
          <div class="mt-3 text-lg">Hello, I am CodropshippingAI assistant</div>
          <div class="mt-2.5 text-sm">How can I help you?</div>
          <div class="mt-2 flex flex-col items-center text-sm">
            <div @click="sendAI('How to check price')" class="my-1 w-64 p-1.5 text-blueBtn text-center rounded-lg underline cursor-pointer" style="background-color: #F2F2F2;">How to check price</div>
            <div @click="sendAI('Services')" class="my-1 w-64 p-1.5 text-blueBtn text-center rounded-lg underline cursor-pointer" style="background-color: #F2F2F2;">Services</div>
            <div @click="sendAI('Become a member')" class="my-1 w-64 p-1.5 text-blueBtn text-center rounded-lg underline cursor-pointer" style="background-color: #F2F2F2;">Become a member</div>
          </div>
        </div>

        <div v-for="(i,n) in chatMessage" :key="n">
          <div v-if="i.is_me == 1">
            <div class="pt-5 pb-2 text-xs text-center text-gray-500">{{i.date_entered}}</div>
            <div class="py-2 flex justify-end">
              <div class="pr-2 flex flex-col items-end" style="width:calc( 100% - 80px )">
                <div class="flex items-end justify-end flex-wrap">
                  <div class="ml-2 text-sm dark:text-gray-400">{{i.nickname}}</div>
                </div>
                <div v-if="i.msg_type == 0" class="mt-1.5 px-3 py-1.5 text-13 text-white rounded-3xl bg-chatMe min-w-40px max-w-full relative break-words">
                  {{i.msg}}
                  <div v-show="i.is_read == 1" class="absolute bottom-0 -left-6">
                    <svg t="1678437391950" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="30218" width="18" height="18"><path d="M511.006881 64.592111c-247.195985 0-447.565479 200.369493-447.565479 447.566502 0 247.168356 200.369493 447.566502 447.565479 447.566502 247.168356 0 447.566502-200.398146 447.566502-447.566502C958.573383 264.961604 758.175237 64.592111 511.006881 64.592111zM511.006881 895.376551c-211.645304 0-383.217938-171.59924-383.217938-383.217938 0-211.646328 171.572634-383.217938 383.217938-383.217938s383.217938 171.572634 383.217938 383.217938C894.22482 723.776288 722.652186 895.376551 511.006881 895.376551z" fill="#7a7a7a" p-id="30219"></path><path d="M706.369338 385.719922c-11.580756 0-22.099321 4.700045-29.706579 12.308327L454.6135 620.581997l-137.570215-138.074705c-7.608282-7.609305-18.098193-12.308327-29.706579-12.308327-23.161512 0-41.958624 18.769482-41.958624 41.959647 0 11.580756 4.670369 22.043039 12.252045 29.622668l167.277818 167.837566c7.580652 7.580652 18.098193 12.308327 29.706579 12.308327 11.609409 0 22.099321-4.700045 29.707602-12.308327l0 0.028653 251.754814-252.343215c7.553023-7.580652 12.252045-18.070564 12.252045-29.65132C748.327962 404.491451 729.53085 385.719922 706.369338 385.719922z" fill="#7a7a7a" p-id="30220"></path></svg>
                  </div>
                </div>
                <div v-if="i.msg_type == 2" class="mt-1.5 px-3 py-1.5 text-13 rounded-3xl bg-chatMe min-w-40px max-w-full relative break-words text-blue-700">
                  <a :href="i.msg" target="_blank" class="cursor-pointer underline">{{i.file_name}}</a>
                  <div v-show="i.is_read == 1" class="absolute bottom-0 -left-6">
                    <svg t="1678437391950" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="30218" width="18" height="18"><path d="M511.006881 64.592111c-247.195985 0-447.565479 200.369493-447.565479 447.566502 0 247.168356 200.369493 447.566502 447.565479 447.566502 247.168356 0 447.566502-200.398146 447.566502-447.566502C958.573383 264.961604 758.175237 64.592111 511.006881 64.592111zM511.006881 895.376551c-211.645304 0-383.217938-171.59924-383.217938-383.217938 0-211.646328 171.572634-383.217938 383.217938-383.217938s383.217938 171.572634 383.217938 383.217938C894.22482 723.776288 722.652186 895.376551 511.006881 895.376551z" fill="#7a7a7a" p-id="30219"></path><path d="M706.369338 385.719922c-11.580756 0-22.099321 4.700045-29.706579 12.308327L454.6135 620.581997l-137.570215-138.074705c-7.608282-7.609305-18.098193-12.308327-29.706579-12.308327-23.161512 0-41.958624 18.769482-41.958624 41.959647 0 11.580756 4.670369 22.043039 12.252045 29.622668l167.277818 167.837566c7.580652 7.580652 18.098193 12.308327 29.706579 12.308327 11.609409 0 22.099321-4.700045 29.707602-12.308327l0 0.028653 251.754814-252.343215c7.553023-7.580652 12.252045-18.070564 12.252045-29.65132C748.327962 404.491451 729.53085 385.719922 706.369338 385.719922z" fill="#7a7a7a" p-id="30220"></path></svg>
                  </div>
                </div>
                <div v-if="i.msg_type == 1" class="mt-1.5 relative">
                  <!-- <div @click="openImg($event)" v-html="i.msg" class="messageImg">{{i.msg}}</div> -->
                  <div @click="openImg($event)" class="messageImg">
                    <img :src="i.msg" alt="">
                  </div>
                  <div v-show="i.is_read == 1" class="absolute bottom-0 -left-6">
                    <svg t="1678437391950" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="30218" width="18" height="18"><path d="M511.006881 64.592111c-247.195985 0-447.565479 200.369493-447.565479 447.566502 0 247.168356 200.369493 447.566502 447.565479 447.566502 247.168356 0 447.566502-200.398146 447.566502-447.566502C958.573383 264.961604 758.175237 64.592111 511.006881 64.592111zM511.006881 895.376551c-211.645304 0-383.217938-171.59924-383.217938-383.217938 0-211.646328 171.572634-383.217938 383.217938-383.217938s383.217938 171.572634 383.217938 383.217938C894.22482 723.776288 722.652186 895.376551 511.006881 895.376551z" fill="#7a7a7a" p-id="30219"></path><path d="M706.369338 385.719922c-11.580756 0-22.099321 4.700045-29.706579 12.308327L454.6135 620.581997l-137.570215-138.074705c-7.608282-7.609305-18.098193-12.308327-29.706579-12.308327-23.161512 0-41.958624 18.769482-41.958624 41.959647 0 11.580756 4.670369 22.043039 12.252045 29.622668l167.277818 167.837566c7.580652 7.580652 18.098193 12.308327 29.706579 12.308327 11.609409 0 22.099321-4.700045 29.707602-12.308327l0 0.028653 251.754814-252.343215c7.553023-7.580652 12.252045-18.070564 12.252045-29.65132C748.327962 404.491451 729.53085 385.719922 706.369338 385.719922z" fill="#7a7a7a" p-id="30220"></path></svg>
                  </div>
                </div>
                <div v-if="i.msg_type == 3 || i.msg_type == 4" class="mt-1.5 relative">
                  <div class="p-3 rounded-md bg-white shadow-default">
                    <div class="flex items-center mb-1.5">
                      <img v-show="i.msg.img != ''" :src="i.msg.img" class="w-7 h-7 rounded-full mr-1" alt="">
                      <div class="text-sm font-semibold">{{i.msg.name}}</div>
                    </div>
                    <div v-show="i.msg.date != ''" class="flex items-center">
                      <img src="../../assets/dtdtime.svg" class="w-3 h-3 mr-1" alt="">
                      <div class="text-xs">{{i.msg.date}}</div>
                    </div>
                    <div class="flex items-center my-0.5">
                      <img src="../../assets/dtdprice.svg" class="w-3 h-3 mr-1" alt="">
                      <div class="flex items-center">
                        <div class="text-red-500 font-semibold">{{i.msg.price}}</div>
                        <div v-show="i.msg_type == 3" class="text-xs">{{i.msg.weight}}</div>
                      </div>
                    </div>
                    <div v-show="i.msg.destination != ''" class="flex items-center">
                      <img src="../../assets/dtdlocation.svg" class="w-3 h-3 mr-1" alt="">
                      <div class="text-xs">{{i.msg.destination}}</div>
                    </div>
                  </div>
                  <div v-show="i.is_read == 1" class="absolute bottom-0 -left-6">
                    <svg t="1678437391950" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="30218" width="18" height="18"><path d="M511.006881 64.592111c-247.195985 0-447.565479 200.369493-447.565479 447.566502 0 247.168356 200.369493 447.566502 447.565479 447.566502 247.168356 0 447.566502-200.398146 447.566502-447.566502C958.573383 264.961604 758.175237 64.592111 511.006881 64.592111zM511.006881 895.376551c-211.645304 0-383.217938-171.59924-383.217938-383.217938 0-211.646328 171.572634-383.217938 383.217938-383.217938s383.217938 171.572634 383.217938 383.217938C894.22482 723.776288 722.652186 895.376551 511.006881 895.376551z" fill="#7a7a7a" p-id="30219"></path><path d="M706.369338 385.719922c-11.580756 0-22.099321 4.700045-29.706579 12.308327L454.6135 620.581997l-137.570215-138.074705c-7.608282-7.609305-18.098193-12.308327-29.706579-12.308327-23.161512 0-41.958624 18.769482-41.958624 41.959647 0 11.580756 4.670369 22.043039 12.252045 29.622668l167.277818 167.837566c7.580652 7.580652 18.098193 12.308327 29.706579 12.308327 11.609409 0 22.099321-4.700045 29.707602-12.308327l0 0.028653 251.754814-252.343215c7.553023-7.580652 12.252045-18.070564 12.252045-29.65132C748.327962 404.491451 729.53085 385.719922 706.369338 385.719922z" fill="#7a7a7a" p-id="30220"></path></svg>
                  </div>
                </div>
                <div v-if="i.msg_type == 14" class="mt-1.5 relative">
                  <a :href="i.msgx.url" target="_blank">
                    <img :src="i.msgx.image" style="border-radius: 6px 6px 0 0;max-width: 240px;min-width: 240px;" alt="">
                  </a>
                  <div style="width: 240px;background-color: #ededed;padding: 10px;border-radius: 0 0 6px 6px;">
                    <a :href="i.msgx.url" target="_blank">
                      <div class="productTitleMsg text-13">{{i.msgx.subject}}</div>
                    </a>
                    <div style="padding-top: 6px;color: #e30101;font-weight: 600;">${{i.msgx.price_us}}</div>
                  </div>
                </div>
              </div>
              <img :src="i.head_img" class="flex-shrink-0 w-12 h-12 rounded-full" alt="">
            </div>
          </div>

          <div v-if="i.is_me == 0 && i.msg_type!=15">
            <div class="pt-5 pb-2 text-xs text-center text-gray-500">{{i.date_entered}}</div>
            <div class="py-2 flex">
              <img :src="i.head_img" class="flex-shrink-0 w-12 h-12 rounded-full" alt="">
              <div class="pl-2 flex flex-col items-start" style="width:calc( 100% - 80px )">
                <div class="flex items-start flex-wrap-reverse">
                  <div class="text-sm mr-2 dark:text-gray-400">{{i.nickname}}</div>
                  <!-- <div class="text-xs text-gray-500">{{i.date_entered}}</div> -->
                </div>
                <div class="mt-1.5 px-3 py-1.5 text-13 rounded-3xl bg-gray-200 min-w-40px max-w-full overflow-x-hidden break-words"
                  v-if="i.msg_type == 0">{{i.msg}}</div>
                <div class="mt-1.5 px-3 py-1.5 text-13 rounded-3xl bg-gray-200 min-w-40px max-w-full overflow-x-hidden break-words text-blue-700"
                  v-if="i.msg_type == 2">
                  <a :href="i.msg" download class="cursor-pointer underline">{{i.file_name}}</a>
                </div>
                <!-- <div @click="openImg($event)" v-if="i.msg_type == 1" v-html="i.msg" class="messageImg mt-1.5">{{i.msg}}</div> -->
                <div @click="openImg($event)" v-if="i.msg_type == 1" class="messageImg mt-1.5">
                  <img :src="i.msg" alt="">
                </div>
                <div v-if="i.msg_type == 3 || i.msg_type == 4" class="mt-1.5 relative">
                  <div class="p-3 rounded-md bg-gray-100 shadow-default">
                    <div class="bg-white rounded-md shadow-default overflow-hidden">
                      <div v-show="i.msg_type == 4" class="text-13">
                        <div class="p-2">Cargo Consolidation</div>
                        <table class="w-full table-auto text-center border-t border-l">
                          <tr>
                            <th class="py-2 border-r border-b font-normal">Cabinet type</th>
                            <th class="py-2 border-r border-b font-normal">Volume</th>
                            <th class="py-2 border-r border-b font-normal">Unit price (cabinet)</th>
                          </tr>
                          <tbody>
                            <tr v-for="(ix,nx) in i.msg.price_list" :key="nx">
                              <td class="py-2 border-r border-b">{{ ix.type }}</td>
                              <td class="py-2 border-r border-b">{{ ix.volume }}</td>
                              <td class="py-2 border-r border-b">{{ ix.price }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="p-3">
                        <div class="flex items-center mb-1.5">
                          <img v-show="i.msg.img != ''" :src="i.msg.img" class="w-7 h-7 rounded-full mr-1" alt="">
                          <div class="text-sm font-semibold">{{i.msg.name}}</div>
                        </div>
                        <div v-show="i.msg.date != ''" class="flex items-center">
                          <img src="../../assets/dtdtime.svg" class="w-3 h-3 mr-1" alt="">
                          <div class="text-13">{{i.msg.date}}</div>
                        </div>
                        <div v-show="i.msg.unit_price" class="flex items-center mt-0.5">
                          <img src="../../assets/dtdprice.svg" class="w-3 h-3 mr-1" alt="">
                          <div class="text-13">${{i.msg.unit_price}}/kg</div>
                        </div>
                        <div class="flex items-center my-0.5">
                          <img src="../../assets/dtdprice.svg" class="w-3 h-3 mr-1" alt="">
                          <div class="flex items-center">
                            <div v-show="i.msg_type == 4" class="text-red-500 font-semibold">USD {{i.msg.total_price}}</div>
                            <div v-show="i.msg_type == 4" class="text-13 flex items-center">
                              (<div v-for="(it,nt) in i.msg.type_and_number" :key="nt">
                                <span v-show="nt>0">+</span>
                                {{it.number}} * {{it.type}}
                              </div>)
                            </div>
                            <div v-show="i.msg_type == 3" class="text-red-500 font-semibold">{{i.msg.price}}</div>
                            <div v-show="i.msg_type == 3" class="text-13">{{i.msg.weight}}</div>
                          </div>
                        </div>
                        <div v-show="i.msg.destination != ''" class="flex items-center">
                          <img src="../../assets/dtdlocation.svg" class="w-3 h-3 mr-1" alt="">
                          <div class="text-13">{{i.msg.destination}}</div>
                        </div>
                        <div v-show="i.msg.tax == '1'" class="flex items-center mt-2.5">
                          <div class="py-0.5 px-3 rounded text-13"
                            style="color: #5dba00;background-color: #ebf9ed;">Included Tax</div>
                        </div>
                      </div>
                    </div>
                    <div v-show="i.msg_type == 4" class="mt-4 text-gray-400 text-xs">
                      Tips: Time: Includes route transportation time only
                    </div>
                    <div class="flex justify-center text-sm">
                      <button class="mt-3 py-1.5 px-10 bg-orange hover:bg-orange1 text-white rounded-md"
                        @click="toPriceDetails(i.msg.detail_info,i.msg_type)">Get Discount</button>
                    </div>
                  </div>
                </div>
                <div v-if="i.msg_type == 12" class="mt-1.5 relative text-13">
                  <div class="p-3 rounded-md bg-gray-100 shadow-default">
                    <div class="bg-white rounded-md shadow-default">
                      <div class="p-2">Cargo Consolidation</div>
                      <table v-if="i.msg_state == 0" class="table-auto text-center border-t border-l">
                        <tr>
                          <th class="border-r border-b font-normal">Total Volume(CBM)</th>
                          <th class="border-r border-b font-normal">Number of suppliers</th>
                          <th class="border-r border-b font-normal">Prices(kg)</th>
                        </tr>
                        <tbody>
                          <tr v-for="(ix,nx) in i.msg" :key="nx">
                            <td class="py-2 border-r border-b">{{ ix.volume }}</td>
                            <td class="py-2 border-r border-b">{{ ix.supplier }}</td>
                            <td class="py-2 border-r border-b">{{ ix.price }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-if="i.msg_state == 1" class="px-2 pb-2">
                        <div class="flex">
                          <div class="text-gray-400 w-36">Total volume(CBM):</div>
                          <div>{{ i.msg.volume }}</div>
                        </div>
                        <div class="flex">
                          <div class="text-gray-400 w-36">Number of suppliers:</div>
                          <div>{{ i.msg.suppliers }}</div>
                        </div>
                        <div class="flex items-center">
                          <div class="text-gray-400 w-36">Prices:</div>
                          <div class="text-red-500 font-semibold text-base">${{ i.msg.price }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 text-gray-400 text-xs">
                      <div>Tips: Warehouse address</div>
                      <div>102 Building C, Hezhihe Industrial Park, No. 2990 Songbai Road, Shiyan, Baoan, Shenzhen</div>
                      <div>Customer service call: 0755-28225927/15323780975</div>
                      <div>Name:Andy</div>
                    </div>
                  </div>
                </div>
                <div v-if="i.msg_type == 11" class="mt-1.5 relative text-13">
                  <div class="p-3 rounded-md bg-gray-100 shadow-default max-w-sm">
                    <div class="bg-white rounded-md shadow-default">
                      <div class="p-2">Cargo Consolidation</div>
                      <table v-if="i.msg_state == 0" class="w-full table-auto text-center border-t border-l">
                        <tr>
                          <th class="py-2 border-r border-b font-normal">Service name</th>
                          <th class="py-2 border-r border-b font-normal">Prices</th>
                        </tr>
                        <tbody>
                          <tr v-for="(ix,nx) in i.msg" :key="nx">
                            <td class="py-2 border-r border-b">{{ ix.service_name }}</td>
                            <td class="py-2 border-r border-b">{{ ix.prices }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-if="i.msg_state == 1" class="px-2 pb-2">
                        <div class="flex">
                          <div class="text-gray-400 w-36">Warehouse address:</div>
                          <div>{{ i.msg.warehouse_address }}</div>
                        </div>
                        <div class="flex">
                          <div class="text-gray-400 w-36">Total volume(CBM):</div>
                          <div>{{ i.msg.total_volume }}</div>
                        </div>
                        <div class="flex">
                          <div class="text-gray-400 w-36">Cargo type:</div>
                          <div>{{ i.msg.cargo_type }}</div>
                        </div>
                        <div class="flex">
                          <div class="text-gray-400 w-36">Of boxes:</div>
                          <div>{{ i.msg.of_boxes }}</div>
                        </div>
                        <div class="flex">
                          <div class="text-gray-400 w-36">Inventory time:</div>
                          <div>{{ i.msg.inventory_time }}</div>
                        </div>
                        <div class="flex">
                          <div class="text-gray-400 w-36">Fee days:</div>
                          <div>{{ i.msg.free_days }}</div>
                        </div>
                        <div class="flex">
                          <div class="text-gray-400 w-36">Outbound service:</div>
                          <div>{{ i.msg.outbound_service }}</div>
                        </div>
                        <div class="flex items-center">
                          <div class="text-gray-400 w-36">Prices:</div>
                          <div class="text-red-500 font-semibold text-base">${{ i.msg.free }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 text-gray-400 text-xs">
                      <div>Tips: Warehouse address</div>
                      <div>102 Building C, Hezhihe Industrial Park, No. 2990 Songbai Road, Shiyan, Baoan, Shenzhen</div>
                      <div>Customer service call: 0755-28225927/15323780975</div>
                      <div>Name:Andy</div>
                    </div>
                  </div>
                </div>
                <div class="AI_msg mt-1.5 pl-7 pr-5 py-1.5 text-13 rounded-3xl bg-gray-200 min-w-40px max-w-full overflow-x-hidden break-words"
                  v-if="i.msg_type == 13" v-html="markdownToHtml(i.msg)"></div>
                <div class="mt-1.5 px-3 py-1.5 text-13 rounded-3xl bg-gray-200 min-w-40px max-w-full overflow-x-hidden break-words"
                  v-if="i.msg_type == 5">
                  <div>{{nologinHello[0]}}</div>
                  <div>{{nologinHello[1]}}</div>
                  <div>{{nologinHello[2]}}</div>
                  <div>{{nologinHello[3]}}</div>
                  <div class="mt-2 pt-2 border-t border-gray-700">WhatsApp:{{manageNew.whatsappp}}</div>
                  <div>e-mail:{{manageNew.service_email}}</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="i.msg_type == 999" class="my-3 text-gray-400 text-center text-xs">{{ i.msg }}</div>
        </div>
        <div v-show="waitingAI"
          class="pt-5 text-gray-400 text-center text-xs">AI replies can take 5-10 seconds to reply</div>
        <div v-show="bookingChat"
          class="mt-4 p-3 flex justify-between items-center rounded-md border border-orange relative">
          <svg t="1678422103952" @click="bookingChat = false" class="absolute right-0 -top-3.5 icon cursor-pointer" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2580" width="26" height="26"><path d="M512 128C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384S723.2 128 512 128zM512 832c-179.2 0-320-140.8-320-320s140.8-320 320-320 320 140.8 320 320S691.2 832 512 832z" p-id="2581" fill="#7a7a7a"></path><path d="M672 352c-12.8-12.8-32-12.8-44.8 0L512 467.2 396.8 352C384 339.2 364.8 339.2 352 352S339.2 384 352 396.8L467.2 512 352 627.2c-12.8 12.8-12.8 32 0 44.8s32 12.8 44.8 0L512 556.8l115.2 115.2c12.8 12.8 32 12.8 44.8 0s12.8-32 0-44.8L556.8 512l115.2-115.2C684.8 384 684.8 364.8 672 352z" p-id="2582" fill="#7a7a7a"></path></svg>
          <div class="overflow-ellipsis overflow-hidden whitespace-nowrap text-xs dark:text-gray-400">Do you want to consult {{bookingName}}?</div>
          <button @click="sendBooking" class="ml-3 px-5 py-1.5 bg-orange hover:bg-orange1 text-white rounded-md text-xs">Send</button>
        </div>
        <div v-show="portChat"
          class="mt-4 p-3 flex justify-between items-center rounded-md border border-orange relative">
          <svg t="1678422103952" @click="portChat = false" class="absolute right-0 -top-3.5 icon cursor-pointer" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2580" width="26" height="26"><path d="M512 128C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384S723.2 128 512 128zM512 832c-179.2 0-320-140.8-320-320s140.8-320 320-320 320 140.8 320 320S691.2 832 512 832z" p-id="2581" fill="#7a7a7a"></path><path d="M672 352c-12.8-12.8-32-12.8-44.8 0L512 467.2 396.8 352C384 339.2 364.8 339.2 352 352S339.2 384 352 396.8L467.2 512 352 627.2c-12.8 12.8-12.8 32 0 44.8s32 12.8 44.8 0L512 556.8l115.2 115.2c12.8 12.8 32 12.8 44.8 0s12.8-32 0-44.8L556.8 512l115.2-115.2C684.8 384 684.8 364.8 672 352z" p-id="2582" fill="#7a7a7a"></path></svg>
          <div class="overflow-ellipsis overflow-hidden whitespace-nowrap text-xs dark:text-gray-400">Do you want to inquire the price of {{portName}}?</div>
          <button @click="sendPort" class="ml-3 px-5 py-1.5 bg-orange hover:bg-orange1 text-white rounded-md text-xs">Send</button>
        </div>
        <div v-show="orderChat"
          class="mt-4 p-3 flex justify-between items-center rounded-md border border-orange relative">
          <svg t="1678422103952" @click="orderChat = false" class="absolute right-0 -top-3.5 icon cursor-pointer" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2580" width="26" height="26"><path d="M512 128C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384S723.2 128 512 128zM512 832c-179.2 0-320-140.8-320-320s140.8-320 320-320 320 140.8 320 320S691.2 832 512 832z" p-id="2581" fill="#7a7a7a"></path><path d="M672 352c-12.8-12.8-32-12.8-44.8 0L512 467.2 396.8 352C384 339.2 364.8 339.2 352 352S339.2 384 352 396.8L467.2 512 352 627.2c-12.8 12.8-12.8 32 0 44.8s32 12.8 44.8 0L512 556.8l115.2 115.2c12.8 12.8 32 12.8 44.8 0s12.8-32 0-44.8L556.8 512l115.2-115.2C684.8 384 684.8 364.8 672 352z" p-id="2582" fill="#7a7a7a"></path></svg>
          <div class="text-xs dark:text-gray-400">You may want to inquire about order number {{orderName}}?</div>
          <button @click="sendOrder" class="ml-3 px-5 py-1.5 bg-orange hover:bg-orange1 text-white rounded-md text-xs">Send</button>
        </div>
      </div>
      
    </div>
    <div class="fixed w-full p-2 bottom-12 bg-white" style="box-shadow: 0 0 4px 0 rgba(0,0,0,0.2)">
      <div v-show="entering" class="absolute -top-5 left-2 text-xs text-gray-500">
        The other is typing...</div>
      <div class="flex mb-2">

        <img @click="sendWhatsapp" src="../../assets/whatsapp.png" class="w-8 h-8 mr-2 rounded-full" alt="">
        <div @click="toAuthorization" class="p-1.5 mr-1 rounded-full border flex items-center text-xs">
          <svg t="1754987643529" class="icon mr-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6311" width="18" height="18"><path d="M850.026667 199.68c-0.725333-5.162667-5.12-8.106667-8.810667-8.106667s-82.218667-5.866667-82.218667-5.866666-54.314667-54.314667-60.906666-60.181334c-5.888-5.866667-17.621333-4.416-22.037334-2.944-0.725333 0-11.733333 3.669333-30.826666 9.557334-18.346667-53.589333-50.645333-102.037333-107.178667-102.037334h-5.12C517.504 9.536 496.96 0 480.064 0c-132.117333 0-195.242667 165.162667-215.061333 248.853333-51.413333 16.149333-88.106667 27.157333-92.501334 28.608-28.629333 8.810667-29.354667 9.557333-33.024 36.693334C136.533333 334.72 61.653333 914.645333 61.653333 914.645333L645.226667 1024l316.373333-68.266667c0-0.725333-110.826667-750.933333-111.573333-756.053333zM612.928 140.906667a1690.026667 1690.026667 0 0 0-49.173333 15.424v-11.008c0-32.298667-4.416-58.730667-11.733334-80 29.354667 4.394667 48.426667 37.418667 60.906667 75.584z m-97.621333-68.266667c8.064 20.565333 13.226667 49.194667 13.226666 88.832v5.866667c-32.32 10.282667-66.816 20.565333-102.058666 31.573333 19.84-75.605333 57.258667-112.32 88.832-126.272zM476.373333 35.242667c5.866667 0 11.733333 2.197333 16.896 5.866666-42.581333 19.818667-87.36 69.738667-106.453333 170.304-27.882667 8.810667-55.04 16.874667-80.746667 24.96 22.037333-76.352 75.605333-201.130667 170.304-201.130666z" fill="#95BF47" p-id="6312"></path><path d="M841.216 190.848c-3.669333 0-82.218667-5.866667-82.218667-5.866667s-54.314667-54.314667-60.906666-60.202666a11.797333 11.797333 0 0 0-8.085334-3.669334L645.973333 1024l316.373334-68.266667S851.498667 204.8 850.773333 199.68a12.714667 12.714667 0 0 0-9.557333-8.832z" fill="#5E8E3E" p-id="6313"></path><path d="M538.069333 365.546667l-38.912 115.989333s-34.496-18.346667-76.352-18.346667c-61.653333 0-64.597333 38.890667-64.597333 48.426667 0 52.864 138.026667 73.429333 138.026667 197.482667 0 97.621333-61.674667 160.746667-145.365334 160.746666-100.565333 0-151.210667-62.4-151.210666-62.4l27.157333-88.810666s52.864 45.504 96.896 45.504c29.376 0 41.109333-22.741333 41.109333-39.637334 0-68.992-113.045333-71.936-113.045333-185.706666 0-95.424 68.266667-187.925333 206.997333-187.925334 52.864-0.725333 79.296 14.677333 79.296 14.677334z" fill="#FFFFFF" p-id="6314"></path></svg>
          Shopify Shop
        </div>
        <div @click="toAuthorization" class="p-1.5 mr-1 rounded-full border flex items-center text-xs">
          <svg t="1754987839663" class="icon mr-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11015" width="18" height="18"><path d="M0 0m192 0l640 0q192 0 192 192l0 640q0 192-192 192l-640 0q-192 0-192-192l0-640q0-192 192-192Z" fill="#000000" p-id="11016"></path><path d="M444.608 416.256V384.64a200.512 200.512 0 0 0-32.512-2.56 241.536 241.536 0 0 0-241.408 241.152c0 82.112 41.088 153.92 103.552 197.568a239.616 239.616 0 0 1-65.024-164.224C208.32 525.76 313.6 418.816 444.608 416.256z" fill="#00F2EA" p-id="11017"></path><path d="M450.56 767.744c59.136 0 107.904-47.04 110.464-106.048V135.744h95.872c-1.664-11.136-3.392-22.208-3.392-33.344H522.496v525.952a110.4 110.4 0 0 1-110.4 106.048c-18.88 0-35.968-4.224-51.392-12.8 20.544 28.16 53.12 46.144 89.92 46.144z" fill="#00F2EA" p-id="11018"></path><path d="M736.512 255.488a179.84 179.84 0 0 1-44.48-119.68h-35.136a183.296 183.296 0 0 0 79.616 119.68zM412.096 513.792c-60.8 0-110.464 49.6-110.464 110.272 0 42.816 24 79.552 59.072 97.536-12.8-17.92-20.48-40.192-20.48-64.128 0-60.8 49.6-110.336 110.4-110.336 11.072 0 22.208 1.664 32.512 5.12V417.92a200.576 200.576 0 0 0-32.512-2.56h-6.016v102.592a135.616 135.616 0 0 0-32.512-4.224z" fill="#FF004F" p-id="11019"></path><path d="M836.672 314.496v101.76a305.664 305.664 0 0 1-182.336-59.008v266.88a241.536 241.536 0 0 1-380.096 197.504 243.008 243.008 0 0 0 177.216 76.992 241.536 241.536 0 0 0 241.408-241.152v-266.88a313.6 313.6 0 0 0 182.4 59.008V317.888c-13.76 0-26.56-0.832-38.592-3.392z" fill="#FF004F" p-id="11020"></path><path d="M653.44 624.128v-266.88a313.536 313.536 0 0 0 182.4 59.008v-101.76a185.152 185.152 0 0 1-99.328-59.008 182.4 182.4 0 0 1-80.448-119.68H561.024v525.952a110.4 110.4 0 0 1-110.4 105.984 110.72 110.72 0 0 1-89.92-46.144 111.04 111.04 0 0 1-59.072-97.472c0-60.8 49.664-110.336 110.464-110.336 11.136 0 22.208 1.664 32.512 5.12V416.256a241.088 241.088 0 0 0-236.288 241.216c0 63.296 24.832 121.408 65.088 164.16a242.688 242.688 0 0 0 138.688 43.648 241.024 241.024 0 0 0 241.408-241.152z" fill="#FFFFFF" p-id="11021"></path></svg>
          Tiktok Shop
        </div>
      </div>
      <div class="flex items-center">
        <!-- <div class="flex-shrink-0 flex mr-3">
          <div ref="emojiPanel" class="relative">
            <img @click="emojiPanel = !emojiPanel" src="../../assets/emoji.svg" class="w-7 h-7 p-1 rounded hover:bg-gray-200 dark:hover:bg-darkLine cursor-pointer" alt="">
            <div v-show="emojiPanel" class="absolute -top-28 -left-2 w-52 p-2 bg-white dark:bg-darkMain rounded-md shadow-md grid grid-cols-6 gap-1">
              <div v-for="(item,index) in emojiList" :key="index"
                @click="emojiChoose" class="emojiItem">{{ item }}</div>
            </div>
          </div>
          <input type="file"
            style="display: none;"
            id="files"
            ref="iptFileRef"
            @change="uploads" />
          <img @click="upload" src="../../assets/chatUpload.svg"
            class="ml-2 w-7 h-7 p-1 rounded hover:bg-gray-200 dark:hover:bg-darkLine cursor-pointer" alt="">
        </div> -->
        <div class="w-full">
          <input ref="textArea" @blur="cancelEnter" @input="sendEnter"
            @keyup.enter.exact="sendMessage" @keyup.ctrl.enter="listenKey()"
            type="text" class="input text-xs" v-model="msg">
        </div>
        <div class="flex-shrink-0 ml-2.5">
          <button @click="sendMessage" class="rounded py-2 px-3 bg-blue-500 text-13 text-white">Send</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    createCoupons,
    getNotice,
    setNotice,
    getId
  } from '@/api/user'
  import {
    getRate
  } from '@/api/drop'
  import uaParser from 'ua-parser-js'
  import MarkdownIt from 'markdown-it';
  export default {
    data(){
      return{
        // emojiPanel: false,
        // entering: false,
        // msg: '',
        // emojiList: '',

        userName: '',
        head_portrait: '',
        theme: '',
        left: 'open',
        feedbackSuccess: false,
        feedbackLoading: false,
        feedbackMenu: false,
        messageMenu: false,
        noticeMenu: false,
        userMenu: false,
        screenWidth: null,
        first: true,
        isvisited: '',
        feedbackInput: '',
        email: '',
        userID: 0,
        manage: {
          id: 0
        },
        chatLarge: false,
        chatShow: false,
        emojiPanel: false,
        emojiList: [
          '🙂','😁','😂','😊','😍','😐',
          '😕','😒','😢','😭','🎉','❤',
          '👌','👍','🙏','✊','✌','✋',
        ],
        chatMessage: [],
        msg: '',
        websocket: '',
        entering: false,
        startPos: 0,
        endPos: 0,
        formData: null,
        t: null,
        chatNum: 0,
        openImgs: '',
        times: '',
        // startLeft: null,
        // startTop: null,
        offLeft: null,
        offTop: null,
        moveLeft: null,
        moveTop: null,
        point: {
          x: null,
          y: null
        },
        chatMove: true,
        firstLogin: 0,
        firstName: '',
        istoken: false,
        noticeList: [],
        noRead: 0,
        newNotice: null,
        bookingChat: false,
        bookingName: '',
        portChat: false,
        portName: '',
        superLevel: '',
        ruleForm: [],
        nologinHello: [],
        orderChat: false,
        orderName: '',
        openMenu: true,
        manageNew: {},
        firstfun: 1,
        fileType: 1,
        aiEnter: false,
        manageAI: false,
        waitingAI: false,
        waitingTime: null,
        banEnter: false,
        waitSend: '',
        owSend: false,
        param: {},
        rate: 6,
      }
    },
    created() {
      this.$emit('menu', '2')
      this.$emit('ischat', true)
      let cookieArr = document.cookie.split(";");
      for(let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        if(cookiePair[0].indexOf('cargosoonAICookie')!=-1) {
          this.owSend = true
          this.waitSend = cookiePair[1]
          var exp = new Date();
          exp.setTime(exp.getTime() + (-1 * 24 * 60 * 60 * 1000));
          document.cookie=`cargosoonAICookie=${cookiePair[1]};domain=cargosoon.com;path=/;expires=${exp.toGMTString()}`
          break;
        }
      }
    },
    mounted(){
      getRate().then((rez) => {
        this.rate = rez.data.exchange_rate;
      })
      this.param = this.$route.params
      if(this.$store.state.user.token){
        this.istoken = true
      }else{
        this.istoken = false
      }
      if(this.istoken){
        let dt = new Date()
        const userId = JSON.parse(localStorage.getItem('userId'))
        const headImg = JSON.parse(localStorage.getItem('userImg'))
        this.email = JSON.parse(localStorage.getItem('userInfo')).email
        if(this.email == null){
          this.head_portrait = require('../../assets/moren.png')
        }else{
          this.head_portrait = headImg + userId + '_40_40.png?v=' + dt.getTime()
        }
        this.times = dt.getTime()
        let user = JSON.parse(localStorage.getItem('userInfo'))
        // console.log(user,'123gdsgae');
        this.userName = user.first_name + ' ' + user.last_name
        this.userID = user.id
        this.superLevel = user.super_level
        this.firstLogin = user.first_login
        // if(this.firstLogin == 1){
        //   this.$refs.memberMask.style = 'display:block;'
        //   this.$refs.firstloginModal.style = 'display:block;'
        //   setTimeout(()=>{
        //     this.$refs.memberMask.style = 'display:block;opacity:1;'
        //     this.$refs.firstloginModal.style = 'display:block;opacity:1;--tw-scale-x: 1;--tw-scale-y: 1;'
        //   })
        // }
        this.firstName = user.first_name
        if(user.hasOwnProperty('manage')){
          this.manage = user.manage
        }
        this.StartWebSocket()
      }else{
        let code = localStorage.getItem('invitation_codes')
        if(localStorage.getItem('chat_info') && !code){
          let chatInfo = JSON.parse(localStorage.getItem('chat_info'))
          this.manageNew = chatInfo.manage
          this.manage = chatInfo.manage
          localStorage.setItem("manageNew", JSON.stringify(this.manageNew))
          this.ruleForm.id = chatInfo.chat_id
          this.userID = chatInfo.chat_id
          this.StartWebSocket()
        }else{
          getId({
            type: 3,
            code: code
          }).then(res=>{
            localStorage.setItem('invitation_code', res.data.manage.invitation_code);
            localStorage.setItem('chat_info',JSON.stringify(res.data))
            this.manageNew = res.data.manage
            this.manage = res.data.manage
            localStorage.setItem("manageNew", JSON.stringify(this.manageNew))
            this.ruleForm.id = res.data.chat_id
            this.userID = res.data.chat_id
            this.StartWebSocket()
          })
        }

        const ua = uaParser(navigator.userAgent)
        // console.log(ua);
        this.ruleForm.browser = ua.browser.name
        this.ruleForm.sys = ua.os.name + ua.os.version
        this.ruleForm.machine = window.screen.width + '*' + window.screen.height
        
        // this.$refs.memberMask.style = 'display:block;'
        // this.$refs.nologinModal.style = 'display:block;'
        // setTimeout(()=>{
        //   this.$refs.memberMask.style = 'display:block;opacity:1;'
        //   this.$refs.nologinModal.style = 'display:block;opacity:1;--tw-scale-x: 1;--tw-scale-y: 1;'
        // })
      }
    },
    destroyed() {  
      // document.removeEventListener('click', this.even, true) 
      clearInterval(this.t)
    },
    methods:{
      markdownToHtml(item) {
        const md = new MarkdownIt()
        return md.render(item)
      },
      emojiChoose(e) {
        // console.log(e.target.innerText)
        this.insertTxtAndSetcursor(e.target.innerText)
        this.emojiPanel = false
      },
      sendMessage(){
        // this.isReadAll = false
        if(!this.banEnter){
          var message = {
            type: "chat_msg",
            from_user_id: this.userID,
            from_service_id: this.manage.id,
            service_type: 1,
            msg_type: 0,
            msg: this.msg,
            order_state: this.$store.state.user.token,
            msg_source_type: 'app',
            client_source: 2,
          }
          this.websocket.send(JSON.stringify(message))
          this.msg = ''
          if(this.manageAI){
            this.banEnter = true
          }
        }
      },
      listenKey(e){
        this.msg = this.msg + '\n'
      },
      sendEnter(){
        if(this.msg != ''){
          var message = {
            type: "chat_msg_entering",
            from_user_id: this.userID,
            service_type: 1,
            order_state: this.$store.state.user.token,
          }
          this.websocket.send(JSON.stringify(message))
        }else{
          this.cancelEnter()
        }
      },
      cancelEnter(){
        this.getCursorPosition()
        var message = {
          type: "chat_msg_cancel_entering",
          from_user_id: this.userID,
          service_type: 1,
          order_state: this.$store.state.user.token,
        }
        this.websocket.send(JSON.stringify(message))
      },
      getCursorPosition(){
        let element = this.$refs.textArea
        this.startPos = element.selectionStart
        this.endPos = element.selectionEnd
        // if (this.startPos === undefined || this.endPos === undefined) return
      },
      insertTxtAndSetcursor(emoji){
        let element = this.$refs.textArea
        let oldTxt = this.msg
        let result = oldTxt.substring(0, this.startPos) + emoji + oldTxt.substring(this.endPos)
        this.msg = result
        element.focus()
        this.$nextTick(() => {
          element.selectionStart = this.startPos + emoji.length
          element.selectionEnd = this.startPos + emoji.length
        })
      },
      StartWebSocket() {
        this.websocket = new WebSocket("wss://chat.co-logistics.cn/wss")
        // this.websocket = new WebSocket("wss://testchat.cargosoon.online/wss")
        this.websocket.onopen = this.onOpen;
        this.websocket.onclose = this.onClose;
        this.websocket.onmessage = this.onMessage;
        this.websocket.onerror = this.onError;
        // this.onClose()
        
      },
      firstSend(){
        this.firstLogin = 0
        var message = {
          type: "first_login",
          from_user_id: this.userID,
          from_service_id: this.manage.id,
          order_state: this.$store.state.user.token,
          msg_source_type: 'app',
        }
        this.websocket.send(JSON.stringify(message))
        this.chatOpen()
      },
      onOpen(e) {
        if(this.istoken){
          var me_1 = {
            type: "init",
            from_user_id: this.userID,
            service_type: 1,
            status: "",
            order_state: this.$store.state.user.token,
          }
          this.websocket.send(JSON.stringify(me_1))
          // this.pingMessage()
        }else{
          this.nologinMessage()
        }
      },
      pingMessage(){
        let ping = {
          type: "ping",
          from_user_id: this.userID,
          service_type: 1,
          order_state: this.$store.state.user.token,
        }
        clearInterval(this.t)
        this.t = setInterval(() => {
          // console.log(this.websocket.readyState)
          if(this.websocket.readyState == 3){
            this.StartWebSocket()
          }
          this.websocket.send(JSON.stringify(ping))
        }, 30000)
      },
      onClose() {
        // this.websocket.close();
        this.StartWebSocket()
      },
      onMessage(e) {
        var data = JSON.parse(e.data)
        // console.log(data)
        if(data.type == 'init' || data.type == 'chat_msg_list' || data.type == 'no_login_init'){
          if(data.type == 'init'){
            // this.noticeList = data.notice_list.reverse()
            this.noticeList = data.notice_list
            this.noRead = data.no_notice_read
            if(data.mode == 2){
              this.manageAI = true
            //   this.manageNow.image_url = 'https://co-logistics.cn/api/uploads/ai.png'
            //   this.manageNow.englishname = 'Message-AI'
            }
            if(this.owSend){
              this.owtosend()
            }
            if(this.param.msg){
              // console.log(this.param.msg);
              this.sendAI(this.param.msg)
            }
            if(this.param.sendType == 3){
              this.bookingName = JSON.parse(localStorage.getItem('BookItem')).product_name_e
              this.bookingChat = true
            }else if(this.param.sendType == 4){
              this.portName = JSON.parse(localStorage.getItem('PortItem')).company
              this.portChat = true
            }else if(this.param.sendType == 5){
              this.orderName = JSON.parse(localStorage.getItem('OrderItem')).enquiry_no
              this.orderChat = true
            }
            if(localStorage.getItem('askProduct')){
              let proItem = JSON.parse(localStorage.getItem('askProduct'))
              this.sendProduct(proItem.shopId, proItem.psource)
            }
          }
          if(data.type == 'no_login_init'){
            this.manage.id = data.manage_row.id
            this.manage.image_url = data.manage_row.image_url
            this.manage.englishname = data.manage_row.englishname
            this.manage.service_email = data.manage_row.service_email
            this.manage.whatsappp = data.manage_row.whatsappp
            if(data.mode == 2){
              this.manageAI = true
            }
            if(this.owSend){
              this.owtosend()
            }
            if(this.param.msg){
              this.sendAI(this.param.msg)
            }
            if(this.param.sendType == 3){
              this.bookingName = JSON.parse(localStorage.getItem('BookItem')).product_name_e
              this.bookingChat = true
            }
            var message = {
              type: "chat_msg_list",
              from_user_id: this.userID,
              from_service_id: this.manage.id,
              service_type: 1,
              order_state: this.$store.state.user.token,
            }
            this.websocket.send(JSON.stringify(message))
          }
          if(data.type == 'chat_msg_list'){
            if(data.mode == 2){
              this.manageAI = true
            }
          }
          let list = data.message_list
          // console.log(list)
          if(this.firstLogin == 1 && list.length == 0){
            this.firstSend()
            this.chatNum = 1
          }
          for(let n=0;n<list.length;n++){
            list[n].head_img = list[n].head_img + '?v=' + this.times
            if(list[n].msg_type == 3 || list[n].msg_type == 4){
              list[n].msg = JSON.parse(list[n].msg)
            }
            if(list[n].msg_type == 5){
              this.nologinHello = list[n].msg.split(',')
              // console.log(this.nologinHello);
            }
            if(list[n].msg_type == 11 || list[n].msg_type == 12){
              list[n].msg = JSON.parse(list[n].msg)
              if(Object.prototype.toString.call(list[n].msg) == '[object Array]'){
                list[n].msg_state = 0
              }else{
                list[n].msg_state = 1
              }
            }
            // if(list[n].msg_type == 13){
            //   const markdownIt = new MarkdownIt();
            //   list[n].msg = markdownIt.render(list[n].msg);
            // }
            if(list[n].msg_type == 14){
              list[n].msgx = JSON.parse(list[n].msg)
              if(list[n].msgx.url.indexOf('source=5')==-1){
                list[n].msgx.price_us = (Number(list[n].msgx.min_price) / this.rate).toFixed(2)
              }else{
                list[n].msgx.price_us = list[n].msgx.min_price
              }
            }
            // if(list[n].msg_type == 2){
            //   list[n].fileName = list[n].msg.replace("https://co-logistics.cn/api/uploads/chat/images/","")
            // }
          }
          // console.log(list)
          this.chatMessage = list
          this.Height()
        }else if(data.type == 'chat_msg' && data.msg_type != 13){
          this.$emit('messages', true)
          let a = {
            date_entered: data.date_entered,
            head_img: data.head_img + '?v=' + this.times,
            is_me: data.is_me,
            is_read: data.is_read,
            msg: data.msg,
            nickname: data.nickname,
            msg_type: data.msg_type,
          }
          if(data.msg_type == 3 || data.msg_type == 4){
            a.msg = JSON.parse(data.msg)
          }
          if(data.msg_type == 2){
            // a.fileName = data.msg.replace("https://co-logistics.cn/api/uploads/chat/images/","")
            a.file_name = data.file_name
          }
          if(data.msg_type == 11 || data.msg_type == 12){
            a.msg = JSON.parse(data.msg)
            if(Object.prototype.toString.call(a.msg) == '[object Array]'){
              a.msg_state = 0
            }else{
              a.msg_state = 1
            }
          }
          if(data.msg_type == 14){
            console.log(data,'sdfs123');
            a.msgx = JSON.parse(data.msg)
            // a.msgx.price_us = (Number(data.msgx.min_price) / this.rate).toFixed(2)
            if(a.msgx.url.indexOf('source=5')==-1){
              a.msgx.price_us = (Number(a.msgx.min_price) / this.rate).toFixed(2)
            }else{
              a.msgx.price_us = a.msgx.min_price
            }
          }
          this.chatMessage.push(a)
          // if(!this.chatShow){
          //   this.chatNum+=1
          // }
          this.Height()
          if(this.manageAI && data.is_me == 1){
            this.waitingTime = setInterval(()=>{
              this.waitingAI = true
              this.Height()
            },5000)
          }
          if(data.is_me == 0){
            this.banEnter = false
            clearInterval(this.waitingTime)
            this.waitingAI = false
          }
        }else if(data.type == 'chat_msg_entering'){
          this.entering = true
        }else if(data.type == 'chat_msg_cancel_entering'){
          this.entering = false
        }else if(data.type == 'is_read'){
          // this.isReadAll = true
          var message = {
            type: "chat_msg_list",
            from_user_id: this.userID,
            from_service_id: this.manage.id,
            service_type: 1,
            order_state: this.$store.state.user.token,
          }
          this.websocket.send(JSON.stringify(message))
        }else if(data.type == 'switch_mode'){
          if(data.mode == 2){
            this.manageAI = true
          }else{
            this.manageAI = false
            let a = {
              msg: 'Enter the manual service, professional customer service for you!',
              msg_type: 999,
            }
            this.chatMessage.push(a)
            this.Height()
          }
        }

        if(data.msg_type == 13){
          clearInterval(this.waitingTime)
          this.waitingAI = false
          let a = {
            head_img: data.head_img + '?v=' + this.times,
            is_me: data.is_me,
            msg: data.msg,
            nickname: data.nickname,
            msg_type: data.msg_type,
          }
          if(!this.aiEnter){
            this.chatMessage.push(a)
          }else if(this.aiEnter && data.msg != '[DONE]'){
            const markdownIt = new MarkdownIt();
            this.chatMessage[this.chatMessage.length - 1].msg += data.msg
            // this.chatMessage[this.chatMessage.length - 1].msg = markdownIt.renderInline(this.chatMessage[this.chatMessage.length - 1].msg + data.msg)
            this.Height()
          }

          if(data.msg != '[DONE]'){
            this.aiEnter = true
            this.$emit('messages', true)
          }else{
            this.aiEnter = false
            const markdownIt = new MarkdownIt();
            // this.chatMessage[this.chatMessage.length - 1].msg = markdownIt.render(this.chatMessage[this.chatMessage.length - 1].msg)
            this.Height()
            this.banEnter = false
          }
        }

        this.param = {}
      },
      onError(){
        this.StartWebSocket()
      },
      upload(){
        this.$refs.iptFileRef.click()
      },
      uploads(e){
        const files = e.target.files[0]
        this.formData = new FormData()
        this.formData.append('file', files)
        if(files.type.indexOf('image')!=-1){
          this.fileType = 1
        }else{
          this.fileType = 2
        }
        this.tttt()
      },
      async tttt(){
        let res = await fetch('https://mini.cargosoon.online/api/mini/Login/upload_chat', {
        // let res = await fetch('https://www.co-logistics.net/api/admin/login/upload_chat', {
          method: 'POST',
          body: this.formData,
        })
        let data = await res.json()
        if (data.code == "0") {
          // this.isReadAll = false
          var img = data.data.image
          let imgs = 'https://mini.cargosoon.online/api' + img.substr(1)
          if(this.fileType == 1){
            var message = { 
              type: "chat_msg",
              from_user_id: this.userID,
              from_service_id: this.manage.id,
              service_type: 1,
              msg_type: 1,
              // msg: '<img style="max-width:80px;min-height:80px;" src="' + img + '">'
              msg: imgs,
              order_state: this.$store.state.user.token,
              client_source: 2,
            }
            this.websocket.send(JSON.stringify(message))
          }else{
            var msgs = {
              image: imgs,
              file_name: data.data.file_name,
              file_size: data.data.file_size,
              file_type: data.data.file_type, 
            }
            var message = { 
              type: "chat_msg",
              from_user_id: this.userID,
              from_service_id: this.manage.id,
              service_type: 1,
              msg_type: 2,
              // msg: '<img style="max-width:80px;min-height:80px;" src="' + img + '">'
              msg: JSON.stringify(msgs),
              order_state: this.$store.state.user.token,
              client_source: 2,
            }
            this.websocket.send(JSON.stringify(message))
          }
          
        }
      },
      async chatOpen(){
        // this.chatMove = true
        // this.chatShow =! this.chatShow
        this.chatNum = 0
        // if(this.istoken){
        var message = {
          type: "chat_msg_list",
          from_user_id: this.userID,
          from_service_id: this.manage.id,
          service_type: 1,
          order_state: this.$store.state.user.token,
        }
        this.websocket.send(JSON.stringify(message))
        // }else{
        //   this.nologinMessage()
        // }
        // this.$refs.chatShow.style = 'display:flex;'
        // this.$refs.chatShow.style.display = 'flex'
        // setTimeout(()=>{
        //   // this.$refs.chatShow.style = 'display: flex;opacity: 1;'
        //   this.$refs.chatShow.style.display = 'flex'
        //   this.$refs.chatShow.style.opacity = 1
        //   this.$refs.chatShow.style.left = this.point.x + 'px'
        //   this.$refs.chatShow.style.top = this.point.y + 'px'
        // },1)
      },
      Height(){
        this.$nextTick(() => {
          this.$refs.chatPanels.scrollTop = this.$refs.chatPanels.scrollHeight
        })
      },
      closeChat(){
        // this.chatShow = false
        // setTimeout(()=>{
        //   this.$refs.chatShow.style = 'display: none;opacity: 0;'
        // },1)
      },
      openImg(e){
        this.openImgs = e.target.src
        this.$refs.maskImg.style.display = 'block'
        this.$refs.openImgPanel.style.display = 'flex'
      },
      closeImgMask() {
        this.$refs.maskImg.style.display = 'none'
        this.$refs.openImgPanel.style.display = 'none'
      },
      dragenter(e){
        e.preventDefault()
      },
      chatmove(e){
        // this.startLeft = e.clientX
        // this.startTop = e.clientY
        this.offLeft = e.offsetX
        this.offTop = e.offsetY
      },
      chatmoving(e){
        this.chatMove = false
        let menuWidth = 0
        if(this.left == 'open'){
          menuWidth = 250
        }
        this.point.x = e.clientX - this.offLeft - menuWidth
        this.point.y = e.clientY - this.offTop - 48
        // this.$nextTick(() => {
        //   this.$refs.chatShow.style.left = this.point.x + 'px'
        //   this.$refs.chatShow.style.top = this.point.y + 'px'
        // })
      },
      showMsg(quoteMsg){
        var message = {
          type: "chat_msg",
          from_user_id: this.userID,
          from_service_id: this.manage.id,
          service_type: 1,
          msg_type: 0,
          msg: 'Quick quote: ' + quoteMsg,
          order_state: this.$store.state.user.token,
          msg_source_type: 'app',
          client_source: 2,
        }
        this.websocket.send(JSON.stringify(message))
        this.chatOpen()
      },
      accessNotice(){
        this.newNotice = setInterval(() => {
          getNotice().then(res=>{
            if(res.data.msg){
              res.data.is_read = 0
              this.noRead = Number(this.noRead)+1
              this.noticeList.unshift(res.data)
            }
            if(res.data.msg == 'You have earned L2 membership benefits'){
              this.superLevel = 'L2'
              let userInfo = JSON.parse(localStorage.getItem('userInfo'))
              userInfo.super_level = 'L2'
              localStorage.setItem('userInfo',JSON.stringify(userInfo))
            }
            // else{
            //   console.log(this.noticeList);
            // }
            
            // this.noticeList = res.data
            // console.log(this.noticeList);
          })
        }, 60000)
      },
      readAll(){
        setNotice({
          customer_id: JSON.parse(localStorage.getItem('userId')),
          type: 2,
        }).then(res=>{
          for(let n=0;n<this.noticeList.length;n++){
            this.noticeList[n].is_read = 1
          }
          this.noRead = 0
        })
      },
      sendBooking(){
        let a = JSON.parse(localStorage.getItem('BookItem'))
        let b = JSON.parse(localStorage.getItem('SearchForm'))
        // console.log(a,b);
        if(a.total == 0){
          a.total = 'N'
        }
        let msgs = {
          img: a.product_img,
          name: a.product_name_e,
          date: `${a.aging_start}-${a.aging_end} Business Days`,
          price: `$${a.freight}`,
          weight: `(${a.weight}kg/${a.total}ctns)`,
          destination: b.shipping_to_en
        }
        let controlLog = b
        controlLog.control_id = a.id
        controlLog.all_weight = a.weight
        controlLog.control_name = a.product_name
        controlLog.aging_start = a.aging_start
        controlLog.aging_end = a.aging_end
        controlLog.transport_type = a.transport_type
        controlLog.freight = a.freight
        controlLog.cutomer_id = this.userID

        // console.log(controlLog);
        var message = {
          type: "chat_msg_control",
          from_user_id: this.userID,
          from_service_id: this.manage.id,
          msg: msgs,
          msg_type: 3,
          control_log: controlLog,
          order_state: this.$store.state.user.token,
        }
        this.websocket.send(JSON.stringify(message))
        this.bookingChat = false
      },
      sendPort(){
        let a = JSON.parse(localStorage.getItem('PortItem'))
        let b = JSON.parse(localStorage.getItem('PortSearch'))
        let c = {}
        // console.log(a,b);
        if(a.gp20 == 0){
          c.gp20 = 'N'
        }else{
          c.gp20 = '$'+a.gp20
        }
        if(a.gp40 == 0){
          c.gp40 = 'N'
        }else{
          c.gp40 = '$'+a.gp40
        }
        if(a.hq40 == 0){
          c.hq40 = 'N'
        }else{
          c.hq40 = '$'+a.hq40
        }
        if(a.hq45 == 0){
          c.hq45 = 'N'
        }else{
          c.hq45 = '$'+a.hq45
        }
        
        let msgs = {
          img: a.img,
          name: a.company,
          date: a.voyage,
          price: `${c.gp20}/${c.gp40}/${c.hq40}/${c.hq45}`,
          destination: b.end_en
        }
        let controlLog = b
        controlLog.company = a.company
        controlLog.customer_id = this.userID
        controlLog.sea_line = a.sea_line
        controlLog.line = a.line
        controlLog.air_day = a.air_day
        controlLog.validity_start = a.validity_start
        controlLog.validity_end = a.validity_end
        controlLog.gp20 = a.gp20
        controlLog.gp40 = a.gp40
        controlLog.hq40 = a.hq40
        controlLog.hq45 = a.hq45

        var message = {
          type: "chat_msg_control",
          from_user_id: this.userID,
          from_service_id: this.manage.id,
          msg: msgs,
          msg_type: 4,
          control_log: controlLog,
          order_state: this.$store.state.user.token,
        }
        this.websocket.send(JSON.stringify(message))
        this.portChat = false
      },
      closeMember(){
        this.$refs.memberMask.style = 'display:none;opacity:0;'
        this.$refs.memberModal.style = 'display:none;opacity:0.2;--tw-scale-x: 0.5;--tw-scale-y: 0.5;'
        this.$refs.nologinModal.style = 'display:none;opacity:0.2;--tw-scale-x: 0.5;--tw-scale-y: 0.5;'
        this.$refs.firstloginModal.style = 'display:none;opacity:0.2;--tw-scale-x: 0.5;--tw-scale-y: 0.5;'
      },
      setSuperLevel(item){
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        userInfo.super_level = item
        localStorage.setItem('userInfo',JSON.stringify(userInfo))
        this.superLevel = item
      },
      nologinMessage(){
        // this.isReadAll = false
        let code = localStorage.getItem('invitation_codes')
        var message = {
          type: "no_login_init",
          sys: this.ruleForm.sys,
          browser: this.ruleForm.browser,
          machine: this.ruleForm.machine,
          from_user_id: this.ruleForm.id,
          code: code,
          manage: this.manageNew,
          order_state: this.$store.state.user.token,
        }
        this.websocket.send(JSON.stringify(message))
        localStorage.removeItem('invitation_codes')
      },
      sendOrder(){
        let controlLog = JSON.parse(localStorage.getItem('OrderItem'))
        let c = {}

        if(controlLog.num == '0'){
          c.num = 'N'
        }else{
          c.num = controlLog.num
        }
        if(controlLog.weight == '0'){
          c.weight = 'N'
        }else{
          c.weight = controlLog.weight
        }
        if(controlLog.volume == '0'){
          c.volume = 'N'
        }else{
          c.volume = controlLog.volume
        }

        let msgs = {
          img: '',
          name: `Order ${controlLog.enquiry_no}`,
          date: '',
          price: '',
          weight: `(${c.num}ctns/${c.weight}kg/${c.volume}cbm)`,
          destination: ''
        }

        var message = {
          type: "chat_msg_control",
          from_user_id: this.userID,
          from_service_id: this.manage.id,
          msg: msgs,
          msg_type: 3,
          control_log: controlLog,
          order_state: this.$store.state.user.token,
        }
        this.websocket.send(JSON.stringify(message))
        this.orderChat = false
      },
      OpenMenu(){
        this.openMenu = !this.openMenu
        if(this.openMenu){
          this.$refs.pullIcons.style = "transform: rotate(90deg)"
        }else{
          this.$refs.pullIcons.style = "transform: rotate(0deg)"
        }
      },
      menuLock(){
        this.$refs.lockModal.style = "display:block;opacity:0.7;--tw-scale-x: 1;--tw-scale-y: 1;"
        setTimeout(()=>{
          this.$refs.lockModal.style = 'display:none'
        },1500)
      },
      sendAI(msgAI){
        var message = {
          type: "chat_msg",
          from_user_id: this.userID,
          from_service_id: this.manage.id,
          service_type: 1,
          msg_type: 0,
          msg: msgAI,
          order_state: this.$store.state.user.token,
          msg_source_type: 'app',
          client_source: 2,
        }
        this.websocket.send(JSON.stringify(message))
        if(this.manageAI){
          this.banEnter = true
        }
      },
      toPriceDetails(item,type){
        // console.log(item);
        if(type == 3){
          localStorage.setItem("mbbookingform", JSON.stringify(item))
          this.$router.push({
            name:'bookingSearch',
          })
        }else{
          item.manage_id = this.manage.id
          localStorage.setItem("mbptp", JSON.stringify(item))
          this.$router.push({
            name:'portSearch',
          })
        }
      },
      owtosend(){
        var message = {
          type: "chat_msg",
          from_user_id: this.userID,
          from_service_id: this.manage.id,
          service_type: 1,
          msg_type: 0,
          msg: this.waitSend,
          order_state: this.$store.state.user.token,
          msg_source_type: 'app',
          client_source: 2,
        }
        this.websocket.send(JSON.stringify(message))
        this.owSend = false
      },
      closeMsg(){
        this.$emit('messages', false)
        this.$router.go(-1);
      },
      sendProduct(id,source){
        var message = {
          type: "chat_msg",
          from_user_id: this.userID,
          from_service_id: this.manage.id,
          service_type: 1,
          msg_type: 14,
          msg: id,
          source: source,
          client_source: 2,
        }
        this.websocket.send(JSON.stringify(message))
        localStorage.removeItem('askProduct')
      },
      sendWhatsapp(){
        window.open('https://api.whatsapp.com/send?phone='+this.manage.whatsappp+'&text=Hello, '+this.manage.englishname,"_blank")
      },
      toAuthorization(){
        this.$emit('messages', false)
        this.$router.push({name:'authorization'})
      },
    }
  }
</script>

<style>
  /* .AI_msg p{
    margin: 0px 10px 0px 16px !important;
  } */
  .AI_msg a{
    color: #4CA2FE !important;
  }
  .AI_msg ol{
    list-style-type: demical !important;
  }
  .AI_msg ol>li>ul{
    list-style-type: circle !important;
  }
  .AI_msg>ul{
    list-style-type: disc !important;
  }
  .AI_msg>ul>li>ul{
    list-style-type: circle !important;
  }
 </style>